import { render, staticRenderFns } from "./locationItem.vue?vue&type=template&id=15d8de76&scoped=true"
import script from "./locationItem.vue?vue&type=script&lang=js"
export * from "./locationItem.vue?vue&type=script&lang=js"
import style0 from "./locationItem.vue?vue&type=style&index=0&id=15d8de76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d8de76",
  null
  
)

export default component.exports